module.exports = __webpack_public_path__ + "static/media/paint-brush.8e91b6cf.svg";